<!-- 标签管理-快速打标 -->
<template>
    <div v-loading="loading">
        <div class="search-ctn">
            <div class="search-ctn-left">
                <div class="flex">
                    <div class="search-name">仓库</div>
                    <div>
                        <el-select
                            v-model="searchData.WarehouseId"
                            size="small"
                            filterable
                            clearable
                            :loading="selLoading"
                            @change="
                                val => {
                                    searchData.ShelfSpaceId = '';
                                    ShelfSpacesList = [];
                                }
                            "
                            @visible-change="
                                val => {
                                    if (val && WarehouseList.length == 0) getWarehouse();
                                }
                            "
                        >
                            <el-option v-for="optionItem in WarehouseList" :label="optionItem.WarehouseName" :value="optionItem.WarehouseId" :key="optionItem.WarehouseId">
                            </el-option>
                        </el-select>
                    </div>
                    <div class="search-name">仓位</div>
                    <div>
                        <el-select
                            v-model="searchData.ShelfSpaceId"
                            filterable
                            clearable
                            reserve-keyword
                            remote
                            :remote-method="searchShelfSpaces"
                            @visible-change="pVisibleChange($event)"
                            v-select-scroll-more="shelfSpaceLoad"
                            size="small"
                        >
                            <el-option v-for="optionItem in ShelfSpacesList" :key="optionItem.ShelfSpaceId" :label="optionItem.ShelfSpaceCode" :value="optionItem.ShelfSpaceId">
                            </el-option>
                            <el-option v-if="selLoading" disabled value style="text-align: center"> 加载中 <i class="el-icon-loading"></i> </el-option>
                        </el-select>
                    </div>
                    <div class="search-name">汽配编码</div>
                    <div>
                        <el-input class="search-item" size="small" v-model.trim="searchData.APCode" placeholder="汽配编码"></el-input>
                    </div>
                    <div class="search-name">汽配名称</div>
                    <el-input v-model.trim="searchData.GoodsName" class="search-item" size="small" style="width: 200px" placeholder="汽配名称"></el-input>
                    <el-button size="small" icon="el-icon-search" class="search-btn btn-primary" @click="handleSearch">查询</el-button>
                    <el-button size="small" icon="el-icon-refresh" class="search-btn btn-primary" @click="resetSearch">重置</el-button>
                    <el-button size="small" class="search-btn btn-primary" v-if="tableDataLength>0" @click="batchPrint()">批量打印</el-button>
                </div>
            </div>
        </div>
        <div class="table-ctn">
            <el-table :header-cell-style="{ background: '#F2F6FC' }"
                @sort-change="sortChange" :data="tableData" border ref="multipleTable" @selection-change="handleSelectionChange" :row-key="getRowKeys" 
            style="width: 100%; margin-bottom: 10px; overflow-y: auto">
                <el-table-column type="selection" reserve-selection width="55px"></el-table-column>
                <el-table-column show-overflow-tooltip width="200" prop="StorageName" label="存放仓库"></el-table-column>
                <el-table-column show-overflow-tooltip width="200" prop="SpaceCode" label="存放仓位"></el-table-column>
                <el-table-column show-overflow-tooltip width="200" prop="APCode" label="汽配编码"></el-table-column>
                <el-table-column show-overflow-tooltip min-width="200" prop="GoodName" label="汽配名称"></el-table-column>
                <el-table-column fixed="right" sortable="custom" show-overflow-tooltip width="140" prop="UnPrintCount" label="可打标签数"></el-table-column>
                <el-table-column fixed="right" label="操作" width="80">
                    <template slot-scope="scope">
                        <div class="ops-ctn">
                            <el-button title="打印商品标签" size="mini" type="text" @click="printLabel(scope.row)" v-if="scope.row.UnPrintCount > 0">打印</el-button>
                        </div>
                    </template>
                </el-table-column>
            </el-table>
            <el-dialog :close-on-click-modal="false" title="商品标签打印配置" :visible.sync="showPrintSingleLabelsDialog" width="600px" append-to-body>
                <div class="dialog-content" v-if="showPrintSingleLabelsDialog">
                    <printSpaceGoodsLabelSet @closeDialog="closePrintSingleLabelsDialog" :ShelfSpaceId="shelfSpaceId" :EntpGoodsId="entpGoodsId"></printSpaceGoodsLabelSet>
                </div>
            </el-dialog>
        </div>
        <div class="dialog-pagination-ctn">
            <el-pagination
                @size-change="handleSizeChange"
                @current-change="handleCurrentChange"
                :current-page="searchData.Page"
                :page-sizes="[10, 20, 30, 40, 50]"
                :page-size="searchData.Limit"
                layout="total, sizes, prev, pager, next, jumper"
                :total="tableDataLength"
            ></el-pagination>
        </div>
    </div>
</template>
<script>
import printSpaceGoodsLabelSet from '@/components/business/goods/printSpaceGoodsLabelSet.vue';
export default {
    mixins: [],
    name: '',
    props: {},
    components: {
        printSpaceGoodsLabelSet
    },
    data() {
        let userMsg = this.$util.getLocalStorage('userMsg');
        return {
            showPrintSingleLabelsDialog: false,
            userMsg: userMsg,
            loading: false,
            selLoading: false,
            entpGoodsId: '',
            shelfSpaceId: '',
            showprintAllLabel: false,
            searchData: {
                WarehouseId: '',
                ShelfSpaceId: '',
                APCode: '',
                GoodsName: '',
                SortProp: '',
                SortType: '',
                Page: 1,
                Limit: 10
            },
            tableData: [],
            tableDataLength: 0,
            WarehouseList: [],
            ShelfSpacesList: [],
            ssForm: {
                Page: 1,
                Limit: 10,
                stopLoad: false,
                key: ''
            },
            multipleSelection: null
        };
    },
    mounted() {
        this.getTableData();
    },
    methods: {
        resetSearch() {
            this.searchData = {
                WarehouseId: '',
                ShelfSpaceId: '',
                APCode: '',
                GoodsName: '',
                Page: 1,
                Limit: 10
            };
        },
        // 记录每行的key值
        getRowKeys(row) {
            return row.GoodsId + row.SpaceId;
        },
        // 获取仓库列表
        getWarehouse() {
            this.selLoading = true;
            this.$util.getWarehouse().then(data => {
                this.WarehouseList = data;
                this.selLoading = false;
            });
        },
        pVisibleChange(val) {
            if (!val) return;
            let that = this;
            if (that.searchData.WarehouseId && that.ShelfSpacesList.length == 0) {
                that.searchShelfSpaces('');
            }
        },
        // 仓位列表，加载更多
        shelfSpaceLoad() {
            this.ssForm.Page += 1;
            this.searchShelfSpaces();
        },
        searchShelfSpaces(key) {
            let that = this;
            if (!that.searchData.WarehouseId) return;

            if (![undefined].includes(key)) {
                that.ssForm.Page = 1;
                that.ssForm.stopLoad = false;
                that.ssForm.key = key;
                that.ShelfSpacesList = [];
            }
            if (this.ssForm.stopLoad) return;
            that.selLoading = true;
            that.$util
                .GetShelfSpacesList({
                    WarehouseId: that.searchData.WarehouseId,
                    ShelfSpaceCode: that.ssForm.key,
                    Page: that.ssForm.Page,
                    Limit: that.ssForm.Limit,
                    IsLimit: true,
                    IncludecWaste: false
                })
                .then(res => {
                    let data = res.data;
                    if (!data) return;
                    that.ssForm.stopLoad = data.length < that.ssForm.Limit;
                    that.ShelfSpacesList = [...that.ShelfSpacesList, ...data];
                    that.selLoading = false;
                })
                .catch(() => {
                    that.selLoading = false;
                });
        },
        getTableData() {
            let that = this;
            //清掉选择
            that.multipleSelection = [];
            that.$refs.multipleTable.clearSelection();

            that.loading = true;
            that.$util
                .axiosGet({
                    url: '/api/EntpGoodsLabels/GetInSpaceNotPrintedGoods',
                    data: this.searchData,
                    hideLoading: true
                })
                .then(res => {
                    let data = res.data;
                    if (data) {
                        that.tableData = data;
                        that.tableDataLength = res.count;
                    } else {
                        that.tableData = [];
                        that.tableDataLength = 0;
                    }
                    that.loading = false;
                })
                .catch(() => {
                    that.loading = false;
                })
                .finally(() => {
                    that.loading = false;
                });
        },
        sortChange(event) {
            this.searchData.SortProp = event.prop;
            this.searchData.SortType = event.order;
            this.searchData.Page = 1;
            this.getTableData();
        },
        printLabel(row) {
            let that = this;
            if (row) {
                that.entpGoodsId = row.GoodsId;
                that.shelfSpaceId = row.SpaceId;
                that.showPrintSingleLabelsDialog = true;
            } else {
                that.$util.warningMsg('请选择商品进行打印标签');
                return;
            }
        },
        //关闭订单弹出层
        closePrintSingleLabelsDialog(fresh) {
            this.entpGoodsId = '';
            this.shelfSpaceId = '';
            this.showPrintSingleLabelsDialog = false;
            if (fresh) this.getTableData();
        },
        batchPrint() {
            let that = this;
            if (!that.multipleSelection || that.multipleSelection.length == 0) {
                this.$util.warningMsg('请选择商品进行打印标签');
                return;
            }

            let goodsList = [];
            that.multipleSelection.forEach(x => {
                goodsList.push({ GoodsId: x.GoodsId, shelfSpaceId: x.SpaceId,APCode:x.APCode });
            });

            that.$util.elConfirm({
                content: '谨慎操作！全部打印会默认一个标签码对应一件商品，确定要打印全部商品的标签吗？',
                noMsg: true,
                confirm() {
                    that.loading = true;
                    that.$util
                        .axiosPost({
                            url: '/api/EntpGoodsLabels/BattchPrintInSpaceGoods',
                            data: {
                                GoodsList: goodsList,
                            },
                            hideLoading: true
                        })
                        .then(res => {
                            that.loading = false;
                              let printedCount = res.data.printCount;
                            if (res.errcode == 0) {
                                that.$util.successMsg('打印成功，已打印商品数：' + printedCount);
                                that.getTableData();
                            } else that.$util.errorMsg(res.errmsg);
                        }).catch(() => {
                            that.loading = false;
                        })
                        .finally(() => {
                            that.loading = false;
                        });
                }
            });
        },        
        handleSelectionChange(val) {
            this.multipleSelection = val;
        },        
        handleSearch() {
            this.searchData.Page = 1;
            this.getTableData();
        },
        handleSizeChange(val) {
            this.searchData.Page = 1;
            this.searchData.Limit = val;
            this.getTableData();
        },
        handleCurrentChange(val) {
            this.searchData.Page = val;
            this.getTableData();
        }
    }
};
</script>
